import clsx from 'clsx'
import React, { ElementType } from 'react'
import { ContactUsOption } from '@typesApp/Config'
import { config } from '@config/config'
import { useEnvironment } from '@hooks/useEnvironment'
import { CallUsAction } from './components/CallUsAction'
import { ChatAction } from './components/ChatAction'
import { EmailAction } from './components/EmailAction'
import { FAQAction } from './components/FAQAction'
import styles from './styles/ContactUsPanel.module.scss'

type ContactUsPanelProps = {
  className?: string
}

export const ContactUsPanel: React.FC<ContactUsPanelProps> = ({ className }) => {
  const { lang } = useEnvironment()
  const configOptions = config.getFeatures()?.contactUs
  if (!configOptions?.length) return null

  const componentMap: Record<ContactUsOption, ElementType> = {
    chat: ChatAction,
    email: EmailAction,
    faq: FAQAction,
    phone: CallUsAction,
  }

  return (
    <div className={clsx(styles.contactUs, className)} lang={lang}>
      {configOptions.map((variant, index) => {
        const Action = componentMap[variant]
        return Action ? <Action key={variant} analyticsIndex={index + 1} /> : null
      })}
    </div>
  )
}
